import * as type from './types';
import { createReducer } from "../../util/index";

const initialState = 
{
    // data: [],
};

const fifaWorldCupReducer = createReducer(initialState) ({
    //Export the response to the react.js to get the response data based on type name
    [type.DROPDOWN]: (state, action) => ({
        ...state,
        dropDown: action.value,
    }),
    [type.STORE]: (state, action) => ({
        ...state,
        store: action.value,
    }),
});

export default fifaWorldCupReducer;